import type { HTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div
      className={twMerge(
        "relative min-w-0 rounded-card border border-line bg-surface p-4 transition-colors duration-150 sm:p-5",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
